import Invoicing from "./integrations/Invoicing.js"
import VPFR from "./integrations/vpfr.js"
import Media from "./integrations/media.js"
import SerbiaUtil from "./integrations/serbiaUtil.js"
import Clerk from "./integrations/clerk.js"

export default class Integrations {
    constructor(adapter) {
        this.adapter = adapter
        this.integrations = {
            'protokol-invoicing': new Invoicing(adapter.getIntegrationsClient()),
            'protokol-vpfr': new VPFR(adapter.getIntegrationsClient()),
            'protokol-media': new Media(adapter.getMediaClient()),
            'serbia-utilities': new SerbiaUtil(adapter.getIntegrationsClient()),
            'protokol-clerk': new Clerk(adapter.getIntegrationsClient()),
        }

        this.available = null;
    }

    getSerbiaUtilities() {
        return this.getInterfaceOf('serbia-utilities')
    }

    getMedia() {
        return this.getInterfaceOf('protokol-media')
    }

    getVPFR() {
        return this.getInterfaceOf('protokol-vpfr')
    }

    getInvoicing() {
        return this.getInterfaceOf('protokol-invoicing')
    }

    clerk() {
        return this.getInterfaceOf('protokol-clerk')
    }

    async isInstalled(id) {
        let items = []
        if (this.available) {
            items = this.available
        } else {
            const client = this.adapter.getIntegrationsClient()
            const { data } = await client.get("/integrations")

            this.available = data
            items = data
        }

        return items.find(i => i.id == id) !== undefined
    }

    getInterfaceOf(id) {
        try {
            return this.integrations[id]
        } catch {
            throw new Error(`Interface ${id} not provided`)
        }
    }
}